// extracted by mini-css-extract-plugin
export default {"bulk":"BulkSwitch_bulk__OGO5S","disabled":"BulkSwitch_disabled__hTCEF","label":"BulkSwitch_label__66+5E","sw":"BulkSwitch_sw__ZZUQi"};